import "./PrivacyPolicy.scss";

function PrivacyPolicy({ CLOUDFRONT_URL }) {
  return (
    <div className="privacy_policy">
      <div className="privacy_policy__sections">
        <div className="privacy_policy__section">
          <h1>Introduction</h1>
          <p>
            This Privacy Policy outlines how Coastal Carbon dba Hum.ai
            ("we", "our", or "us") collects, uses, and protects personal data
            when you use our Software as a Service (SaaS) AI product.
            We are committed to safeguarding your privacy and ensuring compliance
            with applicable data protection regulations,
            including the General Data Protection Regulation (GDPR),
            the California Consumer Privacy Act (CCPA), and ISO/IEC 27701.
          </p>
        </div>
        <div className="privacy_policy__section">
          <h1>Information we collect</h1>
          <p>
            We may collect the following types of personal data:
          </p>
          <ul className="privacy_policy__list">
            <li>Contact details (e.g., name, email address)</li>
            <li>Account credentials</li>
            <li>Usage data and log files</li>
            <li>Payment and billing information</li>
            <li>Any content you upload or input into our services.</li>
          </ul>
          <p>
            We also collect data related to the performance and operation
            of our AI systems, which may include anonymized or pseudonymized
            information.
          </p>
        </div>
        <div className="privacy_policy__section">
          <h1>Legal basis for processing (GDPR)</h1>
          <p>
            We process personal data based on the following legal grounds:
          </p>
          <ul className="privacy_policy__list">
            <li>Your consent</li>
            <li>Contractual necessity</li>
            <li>Compliance with legal obligations</li>
            <li>Legitimate interests pursued by us or a third party.</li>
          </ul>
        </div>
        <div className="privacy_policy__section">
          <h1>Use of information</h1>
          <p>
            We use the collected data to:
          </p>
          <ul className="privacy_policy__list">
            <li>Provide, operate, and improve our services</li>
            <li>Personalize your user experience</li>
            <li>Communicate with you about updates and support</li>
            <li>Ensure security and prevent fraud</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </div>
        <div className="privacy_policy__section">
          <h1>Data sharing and disclosure</h1>
          <p>
            We do not sell personal data. We may share data with:
          </p>
          <ul className="privacy_policy__list">
            <li>Third-party service providers who support our services</li>
            <li>Authorities if required by law</li>
            <li>Affiliates and subsidiaries under common control.</li>
          </ul>
        </div>
        <div className="privacy_policy__section">
          <h1>Data retention</h1>
          <p>
            We retain personal data only as long as necessary to fulfill the purposes
            for which it was collected or as required by law.
          </p>
        </div>
        <div className="privacy_policy__section">
          <h1>Your rights (GDPR & CCPA)</h1>
          <p>
            You have rights under GDPR and CCPA, including:
          </p>
          <ul className="privacy_policy__list">
            <li>Right to access your data</li>
            <li>Right to rectify incorrect or incomplete data</li>
            <li>Right to delete your data</li>
            <li>Right to data portability</li>
            <li>Right to object or restrict processing</li>
            <li>Right to opt-out of the sale of personal data (CCPA).</li>
          </ul>
        </div>
        <div className="privacy_policy__section">
          <h1>AI and data privacy</h1>
          <p>
            Our AI systems may process data to generate outputs or predictions.
            We implement strict access controls, data minimization, and anonymization
            where possible to ensure that AI processing respects individual privacy rights.
            No AI processing is used to make automated decisions with legal or similarly
            significant or personal effects. We also ensure human oversight is maintained
            for our AI product.
          </p>
        </div>
        <div className="privacy_policy__section">
          <h1>Data security (ISO/IEC 27701)</h1>
          <p>
            We implement a comprehensive privacy information management system aligned with ISO/IEC 27701.
            This includes:
          </p>
          <ul className="privacy_policy__list">
            <li>Risk assessments and mitigation strategies</li>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular audits and security training</li>
            <li>Incident response and breach notification procedures.</li>
          </ul>
        </div>
        <div className="privacy_policy__section">
          <h1>Changes to this policy</h1>
          <p>
            We may update this policy periodically. We will notify you of any material changes
            via email or through our service.
          </p>
        </div>
        <div className="privacy_policy__section">
          <h1>Contact us</h1>
          <p>
            If you have any questions or concerns about this Privacy Policy, please contact us at:&nbsp;
            <a href="mailto:founders@hum.ai">founders@hum.ai</a>
          </p>
        </div>
        <div className="privacy_policy__section">
          <p>Last edited date: JULY 21, 2025</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
